import { Graph } from "@maxgraph/core";

export const defaultPageMargin: number = 5

export class GraphEx extends Graph {
    drawBorder: boolean = false;
    onWholePage: boolean = false;
    pageMarginTop: number = defaultPageMargin;
    pageMarginBottom: number = defaultPageMargin;
    pageMarginLeft: number = defaultPageMargin;
    pageMarginRight: number = defaultPageMargin;
}